const getCookie: any = (key) => {
  const name = `${key}=`;
  const decodedCookie = decodeURIComponent(document.cookie);
  const cookieArray = decodedCookie.split(';');
  for (let i = 0; i < cookieArray.length; i++) {
    let c = cookieArray[i];
    while (c.charAt(0) === ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) === 0) {
      return c.substring(name.length, c.length);
    }
  }
  return null;
};

const createCookie = (name, value, days?: number) => {
  const d = new Date();
  d.setTime(d.getTime() + ((days || 10000) * 24 * 60 * 60 * 1000));
  const expires = `expires=${d.toUTCString()}`;
  document.cookie = `${name}=${value};${expires};path=/`;
};

const eraseCookie = (name) => {
  createCookie(name, '', -1);
};

export default {
  getCookie,
  createCookie,
  eraseCookie,
};